/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { FancyActionableFirebase } from 'src/app/common/fancy-firebase/generics/FancyActionableFirebase';
import { InvitedUserList } from 'src/app/common/fancy-firebase/services/factories';
import { InvitedUser, InvitedUserFields } from '../models/InvitedUser';
import { escapeEmail } from '@touchplan/common';

export class InvitedUsersApi extends FancyActionableFirebase<InvitedUser, FancyAction, InvitedUserList> {
	constructor(public data: InvitedUserList) {
		super(data);
	}

	//flip persist immediately to true since deferring the index adding is unlikely to be worth the extra effort
	public addItem(initialData: InvitedUserFields) {
		const key = escapeEmail(initialData.email);
		const data = initialData;

		super.addItem(data, key, true);
	}
}
